import React from 'react'
import "./portfolio.css"
import IMG1 from '../../assets/tbo.png'
import IMG2 from '../../assets/AppleSite.png'
import IMG3 from '../../assets/Currency.png'
import IMG4 from '../../assets/IMG45.png'
import IMG5 from '../../assets/xora.png'
import IMG6 from '../../assets/symfony.png'
import IMG7 from '../../assets/golang.avif'
import { FaReact,FaDocker,FaSymfony  } from 'react-icons/fa'
import { TbBrandGolang } from "react-icons/tb";
import { SiTailwindcss } from 'react-icons/si'
import { SiTypescript, SiJavascript,SiNextdotjs,SiPostgresql,SiGoland   } from 'react-icons/si'
import { useTranslation } from "react-i18next";
import { DiSqllite } from "react-icons/di";



const Portfolio = () => {

  const { t } = useTranslation()

  const data = [
    {
      id: 1, 
      image: IMG1, 
      title: t("tributacao"),
      github: 'https://github.com/JoaoVictorLiz/tributacaoOnline',
      demo: 'https://joaovictorliz.github.io/tributacaoOnline/',
      react: <FaReact size={25}/>,
      tailwind: <SiTailwindcss size={25}/>,
      typescript: <SiTypescript size={25}/>,
      liveDemo: true
    },
    {
      id: 2, 
      image: IMG2, 
      title: t("iphone"),
      github: 'https://github.com/JoaoVictorLiz/appleWebsite',
      demo: 'https://appleiphone-website.netlify.app',
      react: <FaReact size={25}/>,
      typescript: <SiJavascript size={25}/>,
      liveDemo: true
    },
    {
      id: 3, 
      image: IMG3, 
      title: t("exchange"),
      github: 'https://github.com/JoaoVictorLiz/currency_quote',
      demo: 'https://currency-quote.vercel.app',
      react: <SiNextdotjs size={25}/>,
      tailwind: <SiTailwindcss size={25}/>,
      typescript: <SiTypescript size={25}/>,
      liveDemo: true
    },
    {
      id: 4, 
      image: IMG4, 
      title: t("devenviroment"),
      github: 'https://github.com/JoaoVictorLiz/Dev-Environment-Docker',
      demo: 'https://hub.docker.com/repository/docker/baronsatoshi/react-docker/general',
      react: <FaDocker size={25}/>,
      liveDemo: false
    },
    {
      id: 5, 
      image: IMG5, 
      title: t("saas"),
      github: 'https://github.com/JoaoVictorLiz/saas_landing_page',
      demo: 'https://saas-landing-page-5o2s5b8qf-joao-victors-projects-7586da3b.vercel.app',
      react: <FaReact size={25}/>,
      tailwind: <SiTailwindcss size={25}/>,
      liveDemo: true
    },
    {
      id: 6, 
      image: IMG6, 
      title: t("symfonyapi"),
      github: 'https://github.com/JoaoVictorLiz/Symfony-API',
      react: <FaSymfony size={25}/>,
      tailwind: <SiPostgresql size={25}/>,
      liveDemo: false
    },
    {
      id: 7, 
      image: IMG7, 
      title: t("goapi"),
      github: 'https://github.com/JoaoVictorLiz/Go_Rest_API',
      react: <SiGoland  size={25}/>,
      tailwind: <DiSqllite size={25}/>,
      liveDemo: false
    }
    
  ]  

  return (
    <section id='portfolio' >
      
      <h5>{t("recentwork")}</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {
          data.map(({id, image, title, github, demo, react, tailwind, typescript,liveDemo}) => {
            return (
              <article key={id} className='portfolio__item'>
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
                <h3>{title}</h3>
                <p className='portfolio__tech'>Techs: {react} {tailwind} {typescript}</p>
                <div className='portfolio__item-cta'>
                  <a href={github} className='btn' target="_blank">Github</a>
                  {
                    liveDemo ? <a href={demo} className='btn btn-primary' target="_blank">{t("livedemo")}</a>  : null
                  }
                </div>
                
            </article>    
            )
          })
        }
      </div>

      <div className='divcenter'>
      <a href="https://github.com/JoaoVictorLiz?tab=repositories" className='btn btn-primary' target="_blank">{t("seemore")}</a>         
      </div>
     
    </section>
  )
}

export default Portfolio